import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import Favicon from "react-favicon";

import App from './App';

import store from './redux/store';

import favicon from './assets/favicon.png';

render(
  <Provider store={store}>
    <Favicon url={favicon} />
    <App />
  </Provider>,
  document.getElementById('root'),
);
